// extracted by mini-css-extract-plugin
export default {"PurchaseItemFormModal":"PurchaseItemFormModal_PurchaseItemFormModal__Xpikc"};